import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import "./App.css";
import theme from "./theme";
import { SignInPage } from "./setup/signin";
import { SignUpPage } from "./setup/signup";
import { ForgotPasswordPage } from "./setup/forgot-password";
import DashboardView from "./views/DashboardView";
import IntegrationsView from "./views/IntegrationsView";
import ReportsView from "./views/ReportsView";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/" element={<DashboardView />} />
          <Route path="/integrations" element={<IntegrationsView />} />
          <Route path="/reports" element={<ReportsView />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
